import type { ILiveSectorTagsQuery } from '../graphql/types';
import type { ISector } from '../types';

/**
 * Flattens the `LiveSectorTags` nodes into the chip row's shape.
 *
 * The heavy lifting the `searchCategories` version had to do — find the sector
 * group, narrow `CategoryUnion` down to `TagsTag` — is gone: `tags` returns
 * `TagsTag` nodes already scoped to the `sector` parent, ordered by display name
 * server-side. The slug de-dupe is kept: it costs one `Set` and it is the chip
 * row's React keys that depend on slugs being unique.
 *
 * Returns an empty list when the query has not resolved or matched nothing.
 */
export const getSectorTags = (
  data: ILiveSectorTagsQuery | undefined
): ISector[] => {
  const seenSlugs = new Set<string>();
  const sectors: ISector[] = [];

  for (const { id, slug, displayName } of data?.tags.nodes ?? []) {
    if (seenSlugs.has(slug)) {
      continue;
    }

    seenSlugs.add(slug);
    sectors.push({ id, slug, displayName });
  }

  return sectors;
};
